import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import SessionStore from 'stores/SessionStore';
import Multiselect from 'components/v2/multi-select';
import CustomerSearch from 'components/site/customer-search';
import DateRangeFilter from 'components/time/DateRangeFilter';
import CalendarIcon from 'components/v2/icons/CalendarIcon';
import { findThirdPartyCarriers } from 'utils/UserWebAPIUtils';
import { getDefaultDateRangeFilter } from 'helpers/date-range';
import AppointmentSearchFilter from './AppointmentSearchFilter';
import CustomerSearchV2 from '../../site/CustomerSearchFilter';

// @TODO
// - Implement bulk container filter
// - Implement

const DEFAULT_DATE_RANGE_VALUES = {
  startValue: 3,
  startTimeUnit: 'days',
  endValue: 10,
  endTimeUnit: 'days',
};
export default function AppointmentFilters({
  onFilterChanged,
  appointmentStatuses,
  appointmentFacilities,
}) {
  const { t } = useTranslation();

  const isAdmin = SessionStore.isAdmin();

  function onAppointmentSelect(key, appointment) {
    onFilterChanged(key, appointment);
  }

  const defaultDateRangeFilter = getDefaultDateRangeFilter({
    options: 'object',
    ...DEFAULT_DATE_RANGE_VALUES,
  });

  const onDateRangeChange = ({ filterType, start, end }) => {
    if (filterType === 'clear') {
      onFilterChanged('window_start', {
        window_start: undefined,
        window_end: undefined,
      });
    } else {
      onFilterChanged('daterange', { start, end });
    }
  };

  return (
    <div>
      <div className="flex flex-col lg:flex-row lg:-mx-2">
        <div className="w-full sm:w-auto sm:py-1 sm:mb-0 mb-2 lg:px-2">
          <DateRangeFilter
            showActionDropDown
            buttonClassName="flex w-full lg:w-48 button bg-white border shadow justify-center"
            onChange={onDateRangeChange}
            key="daterange"
            initialStart={defaultDateRangeFilter.start}
            initialEnd={defaultDateRangeFilter.end}
            label={
              <div className="flex space-x-1">
                <span className="text-green">
                  <CalendarIcon />
                </span>
                <span className="font-normal text-sm text-grey-darker">
                  {t('DATE_RANGE')}
                </span>
              </div>
            }
          />
        </div>
        <div className="w-full sm:w-auto sm:py-1 mb-2 sm:mb-0 lg:px-2">
          <Multiselect
            label={t('LOCATION')}
            searchKey="name"
            valueKey="name"
            items={appointmentFacilities}
            onSelect={(facility) => onFilterChanged('yard', facility)}
            showSearchInput={false}
            showSelectedCount={false}
          />
        </div>
        <div className="w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0">
          <Multiselect
            label={t('STATUS')}
            items={appointmentStatuses}
            onSelect={(status) => onFilterChanged('status', status)}
            showSearchInput={false}
            showSelectedCount={false}
          />
        </div>
        {isAdmin && (
          <div className="w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0">
            <CustomerSearch
              id="customer-search-input-consignee"
              clearOnSelect
              onSelect={(_item, value) => onFilterChanged('consignee', value)}
              placeholder={t('SEARCH_FOR_TYPE', {
                type: 'Consignee',
              })}
              type="consignees"
              authorizedOnly={false}
            />
          </div>
        )}
        {isAdmin && (
          <div className="w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0">
            <CustomerSearch
              id="customer-search-input-shipper"
              clearOnSelect
              onSelect={(_item, value) => onFilterChanged('shipper', value)}
              placeholder={t('SEARCH_FOR_TYPE', {
                type: 'Shipper',
              })}
              type="shippers"
              authorizedOnly={false}
            />
          </div>
        )}
        <div className="w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0">
          <CustomerSearchV2
            id="customer-search-input-carrier"
            clearOnSelect
            onSelect={(_item, value) => onFilterChanged('carrier', value)}
            placeholder={t('SEARCH_FOR_TYPE', {
              type: 'Carrier',
            })}
            searchField="name"
            type="carriers"
            searchCustomers={findThirdPartyCarriers}
            authorizedOnly={false}
            userTag={t('THIRD_PARTY_CARRIER')}
          />
        </div>
        <div className="w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0">
          <AppointmentSearchFilter
            placeholder={t('SEARCH_CONTAINER')}
            searchField="container_number"
            onSelect={(value, row) =>
              onAppointmentSelect('container_number', row)
            }
          />
        </div>
        <div className="w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0">
          <AppointmentSearchFilter
            placeholder={t('SEARCH_MASTER_BILL')}
            searchField="master_bill_number"
            onSelect={(value, row) =>
              onAppointmentSelect('master_bill_number', row)
            }
          />
        </div>
      </div>
    </div>
  );
}
